import React, { useState } from 'react'
import styels from './Card.module.css'
import {motion} from 'framer-motion'
import cardBg from '../../asssists/cardBg.png'
import Flickity from 'react-flickity-component'
import { Link } from 'react-router-dom'
const images = require.context(`../../asssists/p1`,true);
const imagesList = images.keys().map((image) => images(image))
const images2 = require.context(`../../asssists/p2`,true);
const imagesList2 = images2.keys().map((image2) => images2(image2))
const images3 = require.context(`../../asssists/p3`,true);
const imagesList3 = images3.keys().map((image3) => images3(image3))
const images4 = require.context(`../../asssists/p4`,true);
const imagesList4 = images4.keys().map((image4) => images4(image4))
const images5 = require.context(`../../asssists/p5`,true);
const imagesList5 = images5.keys().map((image5) => images5(image5))

const images6 = require.context(`../../asssists/p6`,true);
const imagesList6 = images6.keys().map((image6) => images6(image6))


const images7 = require.context(`../../asssists/p7`,true);
const imagesList7 = images7.keys().map((image7) => images7(image7))



export default function Card() {
  const [isFlip, setIsFlip] =  useState(false)
const [isAnimationg, setIsAnimationg] = useState(false)

const flickityOptions = {
    initialIndex: 1,
    autoPlay: true,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
}

function handleClick(){
    if(!isAnimationg){
        setIsFlip(!isFlip)
        setIsAnimationg(true)
    }
  
}
  return (
    <>
    <section className={styels.CardContainer}>
    <div className="container">
    <div className="row">
    <div className="col-md-4">
    
    <div className={styels.Card}
    onClick={handleClick}
   >
    <motion.div
    initial={false}
    animate={{rotateY: isFlip ? 180 : 360}}
    transition={{duration: 1, ease: "easeInOut"}}
    onAnimationComplete={() => setIsAnimationg(false)}
     className={styels.CardInner}>


     <div className={styels.CardFront}
     style={{backgroundImage: `url(${cardBg})`}}
    >
   
    <div className="text-center text-danger">
    <i className={`fa-solid fa-angles-right fa-4x ${styels.icon}`}></i> 
    <i className={`fa-solid fa-angles-right fa-4x ${styels.icon}`}></i> 
    </div>
</div>
   <div className={styels.CardBack}
   style={{backgroundImage: `url(${cardBg})`}}
  >

 <div className="container">
 <div className="Hold allImagesSlider">
 <Flickity
 className={styels.carousel} // default ''
 elementType={'div'} // default 'div'
 options={flickityOptions} // takes flickity options {}
 disableImagesLoaded={false} // default false
 reloadOnUpdate // default false
 static // default false
 
 >
 {imagesList.map((image, index) => (
   <img className='mx-3 rounded mt-3 p-1' key={index} src={image} alt="" width={60} height={60} />
 ))}
</Flickity>
  
 </div>
<div className={styels.deatails}>
<h4 className='text-center text-info'>Ecomarce Site</h4>
<p className='text-center text-warning'>User Can Login/signUp,add to wishlist/Remove,add to cart/remove,checkout online/offline </p>
</div>

<Link to="https://husseinmo21.github.io/FinalProject/#/login" target='_blank' className="icon-button nav-link text-center">
<i className="fa-solid fa-arrows-to-eye fa-beat-fade fa-4x mt-4"></i>
<h5 className={`mt-3 ${styels.live}`}>Click On Eye To See Live</h5>
</Link> 
 </div> 




 </div>

    </motion.div>
   
    </div>
    
    
    </div>
    <div className="col-md-4">
    
    <div className={styels.Card}
    onClick={handleClick}>
    <motion.div
    initial={false}
    animate={{rotateY: isFlip ? 180 : 360}}
    transition={{duration: 1, ease: "easeInOut"}}
    onAnimationComplete={() => setIsAnimationg(false)}
     className={styels.CardInner}>


     <div className={styels.CardFront}
     style={{backgroundImage: `url(${cardBg})`}}
    >
    <div className="text-center text-danger">
    <i className={`fa-solid fa-angles-right fa-4x ${styels.icon}`}></i> 
    <i className={`fa-solid fa-angles-right fa-4x ${styels.icon}`}></i> 
    </div>
</div>
   <div className={styels.CardBack}
   style={{backgroundImage: `url(${cardBg})`}}
  >

 <div className="container">
 <div className="Hold allImagesSlider">
 <Flickity
 className={styels.carousel} // default ''
 elementType={'div'} // default 'div'
 options={flickityOptions} // takes flickity options {}
 disableImagesLoaded={false} // default false
 reloadOnUpdate // default false
 static // default false
 
 >
 {imagesList2.map((image, index) => (
   <img className='mx-3 rounded mt-3 p-1' key={index} src={image} alt="" width={60} height={60} />
 ))}
</Flickity>
  
 </div>
<div className={styels.deatails}>
<h4 className='text-center text-info'>CatGameSite</h4>
<p className='text-center text-warning fs-5'>User Can Change Background ,InterActive Website </p>
</div>

<Link to="https://husseinmo21.github.io/CatGameWebsite/" target='_blank' className="nav-link icon-button text-center">
<i className="fa-solid fa-arrows-to-eye fa-beat-fade fa-2x mt-4"></i>
<h5 className={`mt-3 ${styels.live}`}>Click On Eye To See Live</h5>
</Link> 
 </div> 




 </div>

    </motion.div>
   
    </div>
    
    
    </div>
    <div className="col-md-4">
    
    <div className={styels.Card}
    onClick={handleClick}>
    <motion.div
    initial={false}
    animate={{rotateY: isFlip ? 180 : 360}}
    transition={{duration: 1, ease: "easeInOut"}}
    onAnimationComplete={() => setIsAnimationg(false)}
     className={styels.CardInner}>


     <div className={styels.CardFront}
     style={{backgroundImage: `url(${cardBg})`}}
    >
   
    <div className="text-center text-danger">
    <i className={`fa-solid fa-angles-right fa-4x ${styels.icon}`}></i> 
    <i className={`fa-solid fa-angles-right fa-4x ${styels.icon}`}></i> 
    </div>
</div>
   <div className={styels.CardBack}
   style={{backgroundImage: `url(${cardBg})`}}
  >

 <div className="container">
 <div className="Hold allImagesSlider">
 <Flickity
 className={styels.carousel} // default ''
 elementType={'div'} // default 'div'
 options={flickityOptions} // takes flickity options {}
 disableImagesLoaded={false} // default false
 reloadOnUpdate // default false
 static // default false
 
 >
 {imagesList3.map((image, index) => (
   <img className='mx-3 rounded mt-3 p-1' key={index} src={image} alt="" width={60} height={60} />
 ))}
</Flickity>
  
 </div>
<div className={styels.deatails}>
<h4 className='text-center text-info'>BookMark</h4>
<p className='text-center text-warning fs-5'>User Can Add Bookmark/remove, Edit Bookmark/visit</p>
</div>

<Link to={"https://husseinmo21.github.io/BookMark/"} target='_blank' className="nav-link icon-button text-center">
<i className="fa-solid fa-arrows-to-eye fa-beat-fade fa-4x mt-4"></i>
<h5 className={`mt-3 ${styels.live}`}>Click On Eye To See Live</h5>
</Link> 
 </div> 




 </div>

    </motion.div>
   
    </div>
    
    
    </div>
    <div className="col-md-4">
    
    <div className={styels.Card}
    onClick={handleClick}>
    <motion.div
    initial={false}
    animate={{rotateY: isFlip ? 180 : 360}}
    transition={{duration: 1, ease: "easeInOut"}}
    onAnimationComplete={() => setIsAnimationg(false)}
     className={styels.CardInner}>


     <div className={styels.CardFront}
     style={{backgroundImage: `url(${cardBg})`}}
    >
    <div className="text-center text-danger">
    <i className={`fa-solid fa-angles-right fa-4x ${styels.icon}`}></i> 
    <i className={`fa-solid fa-angles-right fa-4x ${styels.icon}`}></i> 
    </div>
</div>
   <div className={styels.CardBack}
   style={{backgroundImage: `url(${cardBg})`}}
  >

 <div className="container">
 <div className="Hold allImagesSlider">
 <Flickity
 className={styels.carousel} // default ''
 elementType={'div'} // default 'div'
 options={flickityOptions} // takes flickity options {}
 disableImagesLoaded={false} // default false
 reloadOnUpdate // default false
 static // default false
 
 >
 {imagesList4.map((image, index) => (
   <img className='mx-3 rounded mt-3 p-1' key={index} src={image} alt="" width={60} height={60} />
 ))}
</Flickity>
  
 </div>
<div className={styels.deatails}>
<h4 className='text-center text-info'>Movies </h4>
<p className='text-center text-warning fs-5'>User Can watch trailers/visit main film site watch news</p>
</div>

<Link to={"https://nextjs-movies-web-site.vercel.app/"}  target='_blank' className="nav-link icon-button text-center">
<i className="fa-solid fa-arrows-to-eye fa-beat-fade fa-4x mt-4"></i>
<h5 className={`mt-3 ${styels.live}`}>Click On Eye To See Live</h5>
</Link> 
 </div> 




 </div>

    </motion.div>
   
    </div>
    
    
    </div>
    <div className="col-md-4">
    
    <div className={styels.Card}
    onMouseEnter={handleClick}
    onMouseLeave={handleClick}>
    <motion.div
    initial={false}
    animate={{rotateY: isFlip ? 180 : 360}}
    transition={{duration: 1, ease: "easeInOut"}}
    onAnimationComplete={() => setIsAnimationg(false)}
     className={styels.CardInner}>


     <div className={styels.CardFront}
     style={{backgroundImage: `url(${cardBg})`}}
    >
    <div className="text-center text-danger">
    <i className={`fa-solid fa-angles-right fa-4x ${styels.icon}`}></i> 
    <i className={`fa-solid fa-angles-right fa-4x ${styels.icon}`}></i> 
    </div>
</div>
   <div className={styels.CardBack}
   style={{backgroundImage: `url(${cardBg})`}}
  >

 <div className="container">
 <div className="Hold allImagesSlider">
 <Flickity
 className={styels.carousel} // default ''
 elementType={'div'} // default 'div'
 options={flickityOptions} // takes flickity options {}
 disableImagesLoaded={false} // default false
 reloadOnUpdate // default false
 static // default false
 
 >
 {imagesList5.map((image, index) => (
   <img className='mx-3 rounded mt-3 p-1' key={index} src={image} alt="" width={60} height={60} />
 ))}
</Flickity>
  
 </div>
<div className={styels.deatails}>
<h4 className='text-center text-info'>AI Chat Bot</h4>
<p className='text-center text-warning fs-5'>User Can chat with AI ,ask any question and get answer </p>
</div>

<Link to={"https://husseinmo21.github.io/CodeAlpha_Task3_GPTChat/"}  target='_blank' className="nav-link icon-button text-center">
<i className="fa-solid fa-arrows-to-eye fa-beat-fade fa-4x mt-4"></i>
<h5 className={`mt-3 ${styels.live}`}>Click On Eye To See Live</h5>
</Link> 
 </div> 




 </div>

    </motion.div>
   
    </div>
    
    
    </div>

    <div className="col-md-4">
    
    <div className={styels.Card}
    onClick={handleClick}>
    <motion.div
    initial={false}
    animate={{rotateY: isFlip ? 180 : 360}}
    transition={{duration: 1, ease: "easeInOut"}}
    onAnimationComplete={() => setIsAnimationg(false)}
     className={styels.CardInner}>


     <div className={styels.CardFront}
     style={{backgroundImage: `url(${cardBg})`}}
    >
    <div className="text-center text-danger">
    <i className={`fa-solid fa-angles-right fa-4x ${styels.icon}`}></i> 
    <i className={`fa-solid fa-angles-right fa-4x ${styels.icon}`}></i> 
    </div>
</div>
   <div className={styels.CardBack}
   style={{backgroundImage: `url(${cardBg})`}}
  >

 <div className="container">
 <div className="Hold allImagesSlider">
 <Flickity
 className={styels.carousel} // default ''
 elementType={'div'} // default 'div'
 options={flickityOptions} // takes flickity options {}
 disableImagesLoaded={false} // default false
 reloadOnUpdate // default false
 static // default false
 
 >
 {imagesList6.map((image, index) => (
   <img className='mx-3 rounded mt-3 p-1' key={index} src={image} alt="" width={60} height={60} />
 ))}
</Flickity>
  
 </div>
<div className={styels.deatails}>
<h4 className='text-center text-info'>Basketball</h4>
<p className='text-center text-warning fs-5'>User Can play basketball and get score and rank Have FUn </p>
</div>

<Link to={"https://gamemonetize.com/basketball-scorer-3d-game"}  target='_blank' className="nav-link icon-button text-center">
<i className="fa-solid fa-arrows-to-eye fa-beat-fade fa-4x mt-4"></i>
<h5 className={`mt-3 ${styels.live}`}>Click On Eye To See Live</h5>
</Link> 
 </div> 




 </div>

    </motion.div>
   
    </div>
    
    
    </div>


    <div className="col-md-4">
    
    <div className={styels.Card}
    onClick={handleClick}>
    <motion.div
    initial={false}
    animate={{rotateY: isFlip ? 180 : 360}}
    transition={{duration: 1, ease: "easeInOut"}}
    onAnimationComplete={() => setIsAnimationg(false)}
     className={styels.CardInner}>


     <div className={styels.CardFront}
     style={{backgroundImage: `url(${cardBg})`}}
    >
    <div className="text-center text-danger">
    <i className={`fa-solid fa-angles-right fa-4x ${styels.icon}`}></i> 
    <i className={`fa-solid fa-angles-right fa-4x ${styels.icon}`}></i> 
    </div>
</div>
   <div className={styels.CardBack}
   style={{backgroundImage: `url(${cardBg})`}}
  >

 <div className="container">
 <div className="Hold allImagesSlider">
 <Flickity
 className={styels.carousel} // default ''
 elementType={'div'} // default 'div'
 options={flickityOptions} // takes flickity options {}
 disableImagesLoaded={false} // default false
 reloadOnUpdate // default false
 static // default false
 
 >
 {imagesList7.map((image, index) => (
   <img className='mx-3 rounded mt-3 p-1' key={index} src={image} alt="" width={60} height={60} />
 ))}
</Flickity>
  
 </div>
<div className={styels.deatails}>
<h4 className='text-center text-info'>Hunter Game</h4>
<p className='text-center text-warning fs-5'>User Can Play Hunter Game Online  and reach the finial level </p>
</div>

<Link to={"https://gamemonetize.com/runner-master-3d-game"} target='_blank' className="nav-link icon-button text-center">
<i className="fa-solid fa-arrows-to-eye fa-beat-fade fa-4x mt-4"></i>
<h5 className={`mt-3 ${styels.live}`}>Click On Eye To See Live</h5>
</Link> 
 </div> 




 </div>

    </motion.div>
   
    </div>
    
    
    </div>







    
    </div>
    </div>

    
   
    </section>
    </>
  )
}
